import { Box, Stack } from "@mui/material";

import Text from "../../atoms/Text";
import EmptyIcon from "../../icons/ui/EmptyIcon";
import CreateButton from "../../molecules/CreateProductButton";

const EmptyState = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={"100%"}
    >
      <Stack alignItems="center" justifyContent="center" spacing={3}>
        <EmptyIcon width={120} height={120} />
        <Text variant="title_medium" color="mono.grey.2">
          You don&apos;t have create product yet
        </Text>
        <CreateButton />
      </Stack>
    </Box>
  );
};

export default EmptyState;
